<aside class="stringformat-action big-input-grid-with">
  <div id="stringformat-container">
    <h4><span class="formatText">Format to</span></h4>

      <mat-select [formControl]="formatSelected" >
        <mat-option *ngFor="let o of formatTypes" [value]="o" >{{format[o]}}</mat-option>
      </mat-select>


  </div>
</aside>
